var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPropertiesLinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58Z",
    fill: "#F9FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1211 25.5C19.7069 25.5 19.3711 25.1642 19.3711 24.75V22.7501C19.3711 22.3359 19.7069 22.0001 20.1211 22.0001C20.5353 22.0001 20.8711 22.3359 20.8711 22.7501V24.75C20.8711 25.1642 20.5353 25.5 20.1211 25.5Z",
    fill: "#807E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3312 28.8609C16.3964 29.27 16.1176 29.6544 15.7086 29.7196L13.9754 29.9959C13.5664 30.0611 13.1819 29.7824 13.1167 29.3733C13.0515 28.9643 13.3303 28.5798 13.7393 28.5146L15.4724 28.2383C15.8815 28.1731 16.2659 28.4519 16.3312 28.8609Z",
    fill: "#807E8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4344 26.1688C17.1794 26.4952 16.7081 26.553 16.3817 26.298L13.3194 23.9055C12.993 23.6505 12.9352 23.1791 13.1902 22.8527C13.4452 22.5263 13.9165 22.4685 14.2429 22.7235L17.3052 25.116C17.6316 25.371 17.6894 25.8424 17.4344 26.1688Z",
    fill: "#807E8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9853 16.7438C36.2972 14.6795 39.9377 14.7641 42.1391 16.9394C44.3668 19.1407 44.2697 22.6386 41.9308 24.727L34.6891 31.193C32.3772 33.2573 28.7367 33.1727 26.5353 30.9974C26.2407 30.7063 26.2379 30.2314 26.529 29.9368C26.8202 29.6421 27.295 29.6393 27.5897 29.9305C29.2247 31.5462 31.966 31.6136 33.69 30.0741L40.9318 23.6081C42.6289 22.0928 42.6935 19.596 41.0848 18.0063C39.4497 16.3906 36.7085 16.3232 34.9844 17.8626L30.5309 21.8391C30.222 22.115 29.7478 22.0881 29.472 21.7792C29.1961 21.4702 29.2229 20.9961 29.5319 20.7202L33.9853 16.7438Z",
    fill: "#807E8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.947 40.757C22.7619 42.8318 19.3175 42.7388 17.2464 40.546C15.1731 38.3509 15.2602 34.8815 17.4418 32.7944C17.7411 32.5081 18.2158 32.5186 18.5022 32.8179C18.7885 33.1172 18.778 33.592 18.4787 33.8783C16.8934 35.3949 16.8295 37.9201 18.3369 39.516C19.8417 41.1093 22.3425 41.1728 23.9251 39.6588L23.9396 39.6449L30.0073 34.4312C30.3215 34.1612 30.795 34.197 31.0649 34.5112C31.3349 34.8254 31.299 35.2989 30.9849 35.5688L24.947 40.757ZM23.0527 28.3048C22.7825 27.9908 22.8179 27.5173 23.1319 27.2471L24.2155 26.3143C26.4005 24.2392 29.8451 24.3321 31.9163 26.525C32.2008 26.8261 32.1872 27.3008 31.8861 27.5852C31.5849 27.8696 31.1103 27.8561 30.8258 27.555C29.3211 25.9618 26.8202 25.8982 25.2376 27.4122L25.2234 27.4259L24.1104 28.3839C23.7965 28.6541 23.323 28.6187 23.0527 28.3048Z",
    fill: "#807E8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPropertiesLinked);
export default __webpack_public_path__ + "static/media/no-properties-linked.15e0a302.svg";
export { ForwardRef as ReactComponent };